import React from 'react';

function OxygenFlowMeter() {
  return (
    <>
      <style>{`
        .flowmeter-container {
          padding: 2rem;
          background-color: #f5f7fa;
          font-family: 'Segoe UI', sans-serif;
        }

        .flowmeter-section {
          max-width: 900px;
          margin: 0 auto 2rem;
          background: #ffffff;
          padding: 2rem;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .flowmeter-section h1 {
          font-size: 2.4rem;
          text-align: center;
          color: #2c3e50;
          margin-bottom: 1.5rem;
        }

        .flowmeter-section h3 {
          font-size: 1.5rem;
          color: #34495e;
          margin-top: 2rem;
          margin-bottom: 1rem;
        }

        .flowmeter-section img {
          display: block;
          margin: 1.5rem auto;
          max-width: 30%;

          height: auto;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          object-fit: contain;
        }

        .flowmeter-section p,
        .flowmeter-section ul {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #444;
        }

        .flowmeter-section ul {
          margin-top: 1rem;
          margin-left: 1.5rem;
          list-style-type: disc;
        }

        @media (max-width: 768px) {
          .flowmeter-container {
            padding: 1rem;
          }

          .flowmeter-section {
            padding: 1.2rem;
          }

          .flowmeter-section h1 {
            font-size: 2rem;
          }

          .flowmeter-section h3 {
            font-size: 1.25rem;
          }
        }
      `}</style>

      <main className="flowmeter-container">
        <section className="flowmeter-section">
          <h1>Oxygen Flow Meter</h1>
          <img src="ofm.png" alt="Oxygen Flow Meter" />

          <h3>BPC (Oxygen) Flow Meter</h3>
          <p>
            The strong and reliable BPC flow meter we offer to clients is made by imbibing the latest
            technical improvements for precise measurement of the flow with ±5% accuracy. Some other
            specifications of the product include:
          </p>
          <ul>
            <li>Chrome plated brass body.</li>
            <li>Graduated flow tube and cover made of polycarbonate and are unbreakable.</li>
            <li>Back pressure compensated.</li>
            <li>Standard flow 0–15 LPM.</li>
            <li>Inlet filter made of SS wire net.</li>
          </ul>

          {/* <img src="ofm2.png" alt="Oxygen Flow Meter 2" /> */}
          <br></br>
           <h1>Flow Meter</h1>
          <img src="fm.png" alt="Flow Meter" />
          <p>
            Back pressure compensated flow-meter with precise step-less control of flow make it
            suitable for administration of supplementary level of oxygen through nasal cannula, simple
            face mask, partial rebreathing mask, partial breathing mask, non-rebreather mask,
            resuscitation mask, and bag valve mask.
          </p>
          <p>
            The attached bubble humidifier bottle ensures optimal humidity to mitigate dryness
            experienced during administration.
          </p>
          <p>
            Flowmeters are available in the standard Thorpe style of Oxygen (Adult & Paediatric) & Medical
            Air which can be connected through DISS or Quick Connect adapters.
          </p>
        </section>

        
      </main>
    </>
  );
}

export default OxygenFlowMeter;
